import React, { SetStateAction, useEffect, useState } from "react";
import { Box, Button, Tab, Typography } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Productcard from "../../components/ReTask/index";
import Plus from "../../../src/assests/images/add.svg";
import pdf from "../../../src/assests/images/dicons.svg";
import camera from "../../../src/assests/images/camera.svg";
import archery from "../../../src/assests/images/archery.svg";
import Fileupload from "../FileuploadWithPreview/Fileupload";
import AddName from "../FileuploadWithPreview/AddName";
import AvailbiltyQuestions from "../TaskTabContents/AvailbiltyQuestions";
import EducationalQuestions from "../TaskTabContents/EducationalQuestions";
import TargetQuestions from "../TaskTabContents/TargetQuestions";
import tabbtn from "../../../src/assests/images/tab_btn.svg";
import question from "../../../src/assests/images/message-question.svg";
import tasks from "../../../src/assests/images/tasks.svg";
import galleryadd from "../../../src/assests/images/gallery-add.svg";
import { useTaskContext } from "../store/AlltasksContext";
// import { useVisibilityContext } from '../QuestionInstructions/VisibilityProvider';
import Notes from "../QuestionInstructions/Notes";
import trash from "../../../src/assests/images/trash.svg";
import plus from "../../../src/assests/images/plus_red.svg";
import ImageUploadTask from "../FileuploadWithPreview/ImageUploadTask";
import marker from "../../../src/assests/images/marker_black.svg";
import QuestionsBox from "../QuestionInstructions/QuestionsBox";
import { useParams } from "react-router-dom";

const demostyles = {
  "& .MuiTabs-flexContainer": {
    display: "flex",
    flexWrap: "wrap",
    gap: "17px",
  },
};

const tabbutton = {
  maxWidth: "32.30%",
  flex: "0 0 32.30%",
};

interface TabData {
  label: string;
  value: string;
  content: JSX.Element;
  isEditable: boolean;
  name: string;
  name_hi: string
  image: string;
  isActive: boolean;
}

// interface SectionData {
//   id: number;
//   initialName: string;
//   placeholder: string;
//   markerImage: string;
//   typographyText: string;
//   textValue: string;
//   textValue_hi:string;
//   mainplaceholder: string;
//   value?: string;
//   selectValue: string;
//   optionsslectedvalue:string | null
//   finalcorr?:string
//   correcthint:string,
//   correcthint_hi:string,
//   smallquestionsimage:string[]
//   idid1:number
//   iconimage:string,
//   test245:string,
//   taskimage:string
//   taskinstructions:{ id: number; value: string; image:string }[];
//   dropdownOptions: { id: number; label: string; value: string }[];
//   instructions: { id: number; value: string; value_hi:string,smallimage:string
//     bigimage:string }[];
//   Multiples: { id: number; value: string;value_hi:string; checkvalue: string;smallimage:string
//     bigimage:string ,ismatch:false}[];
//   Checkboxes: { id: number; value: string; checked: boolean }[];
//   rating: { initialStars: number; maxStarsOptions: number[] };
// }
interface SectionData {
  value?: string;
  id: number;
  initialName: string;
  placeholder: string;
  markerImage: string;
  typographyText: string;
  textValue: string;
  textValue_hi: string;
  language: string;
  iconimage: string;
  mainplaceholder: string;
  selectValue: string;
  smallquestionsimage: string[];
  optionsslectedvalue: string | null;
  finalcorr?: string;
  correcthint: string;
  correcthint_hi: string;
    main_question_id: string;
  idid1: number;
  taskinstructions: { id: number; value: string; image: string }[];
  taskimage: string;
  test245: string;
  dropdownOptions: { id: number; label: string; value: string }[];
  instructions: { id: number; value: string; value_hi: string; smallimage: string; bigimage: string }[];
  Multiples: { id: number; value: string; value_hi: string; checkvalue: string; smallimage: string; bigimage: string; ismatch?: boolean }[];
  Checkboxes: { id: number; value: string; checked: boolean }[];
  rating: { initialStars: number; maxStarsOptions: number[] };
}

interface InstructionItem {
  id: number;
  value: string;
}

interface InstructionItem1 {
  id: number;
  value: string;
  image: string;
}

interface CreateTypeProps {
  value: string;
  faltsubmit: boolean;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  Tabname: string;
  Tabname33: string
  setTabname: (value: string) => void;
  iconImage: string;
  setIconImage: React.Dispatch<React.SetStateAction<string>>;
  tabsData: TabData[]; // ✅ Add tabsData prop
  setTabsData: React.Dispatch<React.SetStateAction<TabData[]>>;
  sectionsData: SectionData[];
  setSectionsData: React.Dispatch<React.SetStateAction<SectionData[]>>;
  educationalData: SectionData[];
  seteducationalData: React.Dispatch<React.SetStateAction<SectionData[]>>;
  // instructions22: InstructionItem[];
  // setInstructions: React.Dispatch<React.SetStateAction<InstructionItem1[]>>;
  // state: {
  //   instructions: InstructionItem[];
  //   idid: number;
  //   textname: string;
  // };
  // setState: React.Dispatch<
  //   React.SetStateAction<{
  //     instructions: InstructionItem[];
  //     idid: number;
  //     textname: string;
  //   }>
  // >;

  lang: {
    //taskType: string;
    imgageGifVideo: string;
    uploadImage: string;
    pageLabel: string;
    uploadText: string;
    uploadSize: string;
    instruction: string;
    addInstruction: string;
    option: string;
    questionPoint: string;
    writeHintCorrectOption: string,
    addOptions: string,
    selectCorrectOptionHint: string,
    taskType: string,
    selectTasktype: string,
    questionsTab: string,
    notes: string,
  };

}

export default function CreateType({ Tabname33, value, setValue, setTabname, Tabname, tabsData, setTabsData, sectionsData, setSectionsData, seteducationalData, educationalData
  , iconImage, setIconImage, lang, faltsubmit
}:
  CreateTypeProps) {

    console.log(Tabname, "Tabnam333eTabname")
  // const [value, setValue] = useState<string>("");
  const [TabOpened, setTabOpened] = useState(false);

  const [TabOpened22, setTabOpened22] = useState("");
  // const [Tabname, setTabname] = useState("");
  const handleChange = (_event: React.SyntheticEvent, newValue: string) => { setValue(newValue); };

  const handleTabClick = (tabValue: string) => {
    console.log(tabValue, "tabValue clickedsssss");

    // Ensure state updates immediately
    setValue(tabValue);

    setTabsData((prev) =>
      prev.map((tab) => ({
        ...tab,
        isActive: tab.value === tabValue, // Activate only the clicked tab
      }))
    );

    // Ensure `setValue` is refreshed by using useEffect
    setTabOpened(true); // Mark tabs as opened
  };


  console.log(TabOpened22, "TabOpened22")
  console.log(Tabname33, "Tabname33Tabname33Tabname33Tabname33")
  //*** For additional user clicks  ***//
  const { setShowNoTask, addQuestionss, setShowImageUploadBanner, showNoTask, showImageUploadBanner, } = useTaskContext();
  const { id ,duplicate_id} = useParams();
  // console.log(sectionsData, "sectionsDataxxxxxxxxxxx")

 useEffect(() => {
  if (id || duplicate_id) {
    setTabOpened(true);
  }
}, [id, duplicate_id]); // ✅ dependencies

  const handleClick = () => { setShowNoTask(true); }; // Set the state to show NoTask
  const handleClickImage = () => { setShowImageUploadBanner(true); }; // Set the state to show the ImageUploadBanner
  //*** For additional user clicks  ***//

  // For note ADD in new-tab //
  const gridData = [
    {
      id: 1,
      title: "Notes",
      placeholderPrefix: "Write a note if required",
      notes: [{ id: 1, value: "" }],
    },
  ];
  // For note ADD in new-tab //
  const handleNameChange = (newName: SetStateAction<string>) => {
    setTabsData((prevTabs) =>
      prevTabs.map((tab) =>
        tab.isActive
          ? {
            ...tab,
            name: typeof newName === "function" ? newName(tab.name) : newName,
          }
          : tab
      )
    );
  };
  ;



  console.log(value, "valuessssssssssssssssdddd")
  const handleDeleteSection = (id: number) => {
    setSectionsData((prevData) =>
      prevData.filter((section) => section.id !== id)
    );
  };


  const handleAddNewTab = () => {
    const newTabIndex = tabsData.length + 1;

    const newTab = {
      label: `Item ${newTabIndex}`,
      value: `${newTabIndex}`,
      content: <Productcard Totalcount={0} setTotalcount={function (value: React.SetStateAction<number>): void {
        throw new Error("Function not implemented.");
      }} activecoun={0} setactivecount={function (value: React.SetStateAction<number>): void {
        throw new Error("Function not implemented.");
      }} pendingcount={0} setpendingcount={function (value: React.SetStateAction<number>): void {
        throw new Error("Function not implemented.");
      }} />,
      isEditable: true,
      name: `Add new type N
      ame${newTabIndex}${newTabIndex > 1 ? ',' : ''}`, // Append a comma if it's not the first tab
      name_hi: "",
      image: pdf,
      isActive: false,
    };

    setTabsData([...tabsData, newTab]);
    setValue(newTab.value);
  };




  console.log(Tabname, "tabsDatatabsDatatabsDatatabsDatatabsData")

  const newValue = `Add new type Name ${tabsData.length + 1}`;
  const inputValue = [...tabsData, newValue].join(", ");
  console.log(inputValue, "inputValueinputValueinputValue")
  console.log(sectionsData, "sectionsDataxxxxxxxxxxx")
  console.log(Tabname, "vssssssssssssssss")
  console.log(tabsData, "44444444444444444444444444447777", value, "kkkkkkkkkkkk")
  console.log(faltsubmit, "faltsubmssssssssssit")
  // useEffect(() => {
  //   if (tabsData.length > 0) {
  //     setValue(tabsData[0].value); // Set value to the first tab or handle logic accordingly
  //   }
  // }, [tabsData]);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "24px",
        }}
      >
        <Box>
          <Typography
            variant="h3"
            sx={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#282829",
              marginBottom: "2px",
            }}
          >
            {lang.taskType}*
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontSize: "16px", fontWeight: "400", color: "#696A6B", paddingTop: "10px" }}
          >
            {lang.selectTasktype}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ width: "100%", ...demostyles }}>
        <TabContext value={value}>
          <Box>
            <TabList
              onChange={(event, newValue) => {
                handleChange(event, newValue);
                setTabOpened(true);
              }}
              aria-label="lab API tabs example"
            >
              {tabsData.map((tab, index) => (
                <Box
                  key={tab.value}
                  onClick={() => {
                    handleTabClick(tab.value);
                    setTabname(tab.name)
                    setShowNoTask(false);
                    setShowImageUploadBanner(false);
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    border: "1px solid #E7E8E9",
                    borderRadius: "12px",
                    justifyContent: "start",
                    padding: "0 10px",
                    cursor: "pointer",
                    height: "64px",
                    background: value === tab.value ? "#FFEBEF" : "#FFF",
                    color: value === tab.value ? "#B90022" : "#282829",
                    opacity: value === "" || value === tab.value ? "1" : "0.5",
                    ...tabbutton,
                  }}
                >
                  {tab.isEditable ? (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "19px",
                          justifyContent: "center",
                          padding: "0 0 0 46px",
                        }}
                      >
                        <Fileupload
                          fileuploadclass="tab-upload"
                          iconSrc="iconSrc"
                          onFileSelect={(file) =>
                            console.log("Selected file:", file)
                          }
                          previewSize={{ width: 20, height: 20 }}
                          onRemoveFile={() => console.log("File removed!")}
                        />

                        <AddName
                          setName={handleNameChange}
                          name={tab.name}

                        />



                      </Box>
                    </>
                  ) : (
                    <>
                      <Box
                        sx={{
                          background:
                            value === tab.value ? "#FFF" : "transparent",
                          padding: "6px",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={tab.image || pdf}
                          alt="pdf"
                          style={{ width: "24px", height: "24px" }}
                        />
                      </Box>
                      <Tab
                        sx={{
                          padding: "0",
                          opacity: "1",
                          fontSize: "16px",
                          fontWeight: "600",
                          textTransform: "capitalize",
                        }}
                        label={tab.name || tab.label}
                        value={tab.value}
                      />
                    </>
                  )}
                </Box>
              ))}

            </TabList>
          </Box>
          {tabsData.map((tab) => (
            <TabPanel
              sx={{ padding: "24px 0 0" }}
              key={tab.value}
              value={tab.value}
            >
              {tab.isEditable ? (
                <Typography>
                  <QuestionsBox
                    //  state={state} 
                    //  setState={setState}
                    // setTabname={setTabname}
                    // Tabname={Tabname} 
                    lang={lang}
                    educationalData={educationalData}
                    seteducationalData={seteducationalData}
                    sectionsData={sectionsData}
                    setSectionsData={setSectionsData}
                    onDeleteSection={handleDeleteSection}
                  />
                  {showNoTask && (
                    <Notes
                      gridData={gridData}
                      trashIcon={trash}
                      plusIcon={plus}
                    />
                  )}
                  {showImageUploadBanner && (
                    <ImageUploadTask
                      iconImage={iconImage}
                      setIconImage={setIconImage}
                      sectionTitle={lang.imgageGifVideo}
                      placeholder="Your Name"
                      pageLabel={lang.pageLabel}
                      bannerProps={{
                        title: lang.uploadImage,
                        uploadText: lang.uploadText,
                        uploadSize: lang.uploadSize,
                        imageUrls: "",
                        maintitle: "",
                        setuploadedImage: (image) =>
                          console.log(`Uploaded image: ${image}`),

                      }}
                      instructions={[{ id: 1, value: "", image: "", smallimage: "", bigimage: "" }]}
                      markerImage={marker}
                      onNameChange={handleNameChange}
                      trashIcon={trash}
                      lang={lang}
                    />
                  )}
                </Typography>
              ) : (
                tab.content
              )}
            </TabPanel>
          ))}
          {value === "" && faltsubmit && (
            <Typography sx={{ color: "#B90022", fontSize: "14px", marginTop: "8px" }}>
              Please select at least one tab.
            </Typography>
          )}

        </TabContext>
        <Box sx={{ paddingTop: "24px", opacity: TabOpened ? "1" : "0.4" }}>
          <Box sx={{ textAlign: "center" }}>
            <img src={tabbtn} alt="tabbtn" />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "88px",
              justifyContent: "center",
              paddingTop: "9px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                gap: "7px",
                padding: "0",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              <Button
                // onClick={() => addQuestionss(tabsData[0].name)}
                onClick={() => {
                  const activeTab = tabsData.find((tab) => tab.value === value);
                  console.log(activeTab, "activeTabssssssss")
                  if (activeTab) {
                    addQuestionss(activeTab.name);
                  }
                }}
                sx={{ minWidth: "unset", padding: "0" }}
                disabled={!TabOpened}
              >
                <img
                  style={{
                    padding: "17px",
                    background: "#FFF",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.05)",
                  }}
                  src={question}
                  alt="question"
                />
              </Button>
              <Typography
                sx={{
                  textTransform: "capitalize",
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#282829",
                }}
                variant="body2"
              >
                {lang.questionsTab}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                gap: "7px",
                padding: "0",
                textAlign: "center",
              }}
            >
              <Button
                onClick={handleClickImage}
                sx={{ minWidth: "unset", padding: "0" }}
                disabled={!TabOpened}
              >
                <img
                  style={{
                    padding: "17px",
                    background: "#FFF",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.05)",
                  }}
                  src={galleryadd}
                  alt="galleryadd"
                />
              </Button>
              <Typography
                sx={{
                  textTransform: "capitalize",
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#282829",
                }}
                variant="body2"
              >
                {lang.imgageGifVideo}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                gap: "7px",
                padding: "0",
                textAlign: "center",
              }}
            >
              <Button
                onClick={handleClick}
                sx={{ minWidth: "unset", padding: "0" }}
                disabled={!TabOpened}
              >
                <img
                  style={{
                    padding: "17px",
                    background: "#FFF",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.05)",
                  }}
                  src={tasks}
                  alt="tasks"
                />
              </Button>
              <Typography
                sx={{
                  textTransform: "capitalize",
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#282829",
                }}
                variant="body2"
              >
                {lang.notes}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}